import genericAPI from "@/api/api";
import type {ZUser} from "@schemas/user.schemas";

/**
 * Initializes the push subscription for the user.
 */
export const initPushSubscription = async () => {
    try {
        log.debug("Initializing push subscription...");

        // Check permission first
        const permission = Notification.permission;
        if (permission === "denied") {
            log.warn(`Push notification permission not granted (current: ${permission})`);
            return;
        }

        const registration = await navigator.serviceWorker.ready;

        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
            log.debug("No existing subscription, subscribing...");
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY!)
            });
        } else {
            log.debug("Existing subscription found:", subscription);
        }

        // Optionally: send to backend only if this subscription is new or changed
        const response = await genericAPI.postDocument<ZUser>("users/current/push-subscriptions", subscription);
        log.debug("Push subscription registered with backend:", response);
    } catch (e) {
        log.error("Error initializing push subscription:", e);
    }
};

export const subscribeUser = async () => {
    const registration = await navigator.serviceWorker.ready

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY!)
    })
    // const key = 'BOpq...'; // Base64 public key
    // const converted = Uint8Array.from(atob(key), c => c.charCodeAt(0));
    console.log("subscribeUser subscription", subscription);

    const responseData = await genericAPI.postDocument<ZUser>("users/subscribe", subscription);
    console.log("subscribeUser response", responseData);

}

export const unsubscribeUser = async () => {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
        await subscription.unsubscribe();
        log.debug("User unsubscribed from push notifications.");
    } else {
        log.warn("No active push subscription found to unsubscribe.");
    }

    // Optionally: inform backend about unsubscription
    await genericAPI.deleteDocument("users/current/push-subscriptions", "all");
    log.debug("Push subscription removed from backend.");
}

const urlBase64ToUint8Array = (base64String: string) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
};
